/**
 * Qué producciones abren solas su subtabla de consumo cuando la búsqueda las ha
 * traído POR UN COMPONENTE.
 *
 * El tope NO es de coste de red —el consumo ya viene cargado con la página en
 * los tres rangos—, sino de legibilidad: cada subtabla son diez columnas y
 * varias filas, y una pantalla entera de subtablas tapa el Gantt (medido en la
 * vista anual: abrir las 57 coincidencias pasa el DOM de 2.511 a 11.962 nodos y
 * añade 326 filas de componentes).
 *
 * Antes el tope era TODO-O-NADA: pasado el límite se devolvía el conjunto vacío.
 * Por eso la misma búsqueda desplegaba en la vista semanal (7 coincidencias) y
 * no desplegaba nada en la mensual (36) ni en la anual (57), que es exactamente
 * el fallo que se reportó. Ahora se abren las N primeras EN EL ORDEN EN QUE SE
 * VEN y las demás quedan cerradas pero con su chapa de coincidencia, de modo que
 * ninguna fila se queda sin explicar por qué está ahí.
 *
 * @param ordenVisible    prodids en el orden en el que se pintan en pantalla
 *                        (agrupados por ruta, no el orden de `filteredProds`).
 * @param casaPorComponente ¿alguno de los componentes de esta OP casa?
 * @param max             tope de subtablas abiertas a la vez.
 */
export function opsAutoDesplegadas(
  ordenVisible: string[],
  casaPorComponente: (prodid: string) => boolean,
  max: number,
): Set<string> {
  const abre = new Set<string>()
  if (max <= 0) return abre
  for (const prodid of ordenVisible) {
    if (abre.size >= max) break
    if (casaPorComponente(prodid)) abre.add(prodid)
  }
  return abre
}
